module.exports = __webpack_public_path__ + "static/media/invite.669b117d.png";